import urLnb from "./urLnb.vue";
import urLnbMenuList from "./urLnbMenuList.vue";
import urGnb from "./urGnb.vue";
import urPanel from "./urPanel.vue";

export default {
    install(Vue){
        Vue.component(urLnb.name, urLnb);
        Vue.component(urLnbMenuList.name, urLnbMenuList);
        Vue.component(urGnb.name, urGnb);
        Vue.component(urPanel.name, urPanel);
    }
};
